__turbopack_context__.v({
  "backdrop": "modal-module-scss-module__IbzwgG__backdrop",
  "dialog": "modal-module-scss-module__IbzwgG__dialog",
  "dialogScrollable": "modal-module-scss-module__IbzwgG__dialogScrollable",
  "full": "modal-module-scss-module__IbzwgG__full",
  "lg": "modal-module-scss-module__IbzwgG__lg",
  "md": "modal-module-scss-module__IbzwgG__md",
  "sm": "modal-module-scss-module__IbzwgG__sm",
  "xl": "modal-module-scss-module__IbzwgG__xl",
});
